import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonComponent } from '@shared/components/button';
import { InputComponent } from '@shared/components/input';
import { ReactiveFormsModule } from '@angular/forms';
import { FormMessageComponent } from '@shared/components/forms';
import { IconDirective } from '@ui/components/icon';
import {
  CloseModalDirective,
  DynamicPhoneValidationDirective,
  PhoneNumberMaskDirective,
} from '@shared/directives';
import { getPhonePrefixOptions } from '@shared/utils/get-phone-prefix-options.helper';
import { SelectComponent } from '@shared/components/select';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { RegisterModalFormService } from './services/register-modal-form.service';
import { DYNAMIC_PHONE_VALIDATION_CONFIG } from './constants/dynamic-phone-validation-config.constant';
import { RegisterRedirectionsService } from './services/register-redirections.service';
import { RegisterSubmitDirective } from './directives';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'register-modal',
  imports: [
    InputComponent,
    ButtonComponent,
    ReactiveFormsModule,
    FormMessageComponent,
    IconDirective,
    PhoneNumberMaskDirective,
    SelectComponent,
    DynamicPhoneValidationDirective,
    RegisterSubmitDirective,
    CloseModalDirective,
    MatSlideToggleModule,
  ],
  templateUrl: './register-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RegisterModalFormService, RegisterRedirectionsService],
  styleUrls: ['./register-modal.component.scss'],
})
export class RegisterModal {
  private readonly _registerModalFormService = inject(RegisterModalFormService);

  protected readonly sending = this._registerModalFormService.sending;

  protected readonly registerForm = this._registerModalFormService.registerForm;

  protected readonly phonePrefixOptions = getPhonePrefixOptions();

  protected readonly dynamicPhoneValidationConfig =
    DYNAMIC_PHONE_VALIDATION_CONFIG;

  protected get isPhonePrefixUS() {
    return (
      this.registerForm.controls['prefix_phone'].value ===
      DEFAULT_USA_PHONE_PREFIX
    );
  }

  protected isFirm = this._registerModalFormService.isFirm;
}
